export default {
    route: {
        hidden: true,
        meta: {
            title: '订单详情',
            auth: "sign",
        }
    }
}
